module.exports = __webpack_public_path__ + "img/mobileexperienceLogo.ac69c4be.png";